import React from "react";
import { userAddress } from "../../actions/index";
import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import { ToastContainer, toast, Flip } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { toastConfig } from "../Custom/ToastConfig";
const FA = require("react-fontawesome");

class Address extends React.Component {
  constructor(props) {
    super(props);
    this.name = localStorage.getItem('name');
    this.mobile = localStorage.getItem('mobile');
    this.state = {
      assistance: props.user.assistance,
      address: props.user.address,
      landmark: props.user.landmark,
      area: props.user.area,
      name: localStorage.getItem('name') ? localStorage.getItem('name') : null,
      phone: localStorage.getItem('mobile') ? localStorage.getItem('mobile') : null,
      status: "Session Booked",
      position: "",
      show: false,
      error: "",
      pincode: props.user.pincode,
      submitted: false,
      latitude: null,
      longitude: null,
      locationError: null,
      isGettingLocation: false
    };
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    let self = this;
    
    // Forcefully get user location on component mount
    this.getUserLocation();
    
    ValidatorForm.addValidationRule("isPhoneMatch" || "required", value => {
      if (value !== undefined && value.length === 10) {
        return true;
      }
      return false;
    });
  }

  // Function to forcefully get user location
  getUserLocation = () => {
    this.setState({ isGettingLocation: true, locationError: null });

    if (!navigator.geolocation) {
      this.setState({
        locationError: "Geolocation is not supported by this browser.",
        isGettingLocation: false
      });
      return;
    }

    const options = {
      enableHighAccuracy: true,
      timeout: 10000, // 10 seconds
      maximumAge: 0 // Force fresh location
    };

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
        
        this.setState({
          latitude,
          longitude,
          position: `${latitude},${longitude}`,
          isGettingLocation: false
        }, () => {
          // Send location to API after state is updated
          this.sendLocationToAPI(latitude, longitude);
        });
      },
      (error) => {
        let errorMessage = "Unable to retrieve your location. ";
        
        switch(error.code) {
          case error.PERMISSION_DENIED:
            errorMessage += "Please enable location permissions in your browser settings.";
            break;
          case error.POSITION_UNAVAILABLE:
            errorMessage += "Location information is unavailable.";
            break;
          case error.TIMEOUT:
            errorMessage += "Location request timed out.";
            break;
          default:
            errorMessage += "An unknown error occurred.";
            break;
        }
        
        this.setState({
          locationError: errorMessage,
          isGettingLocation: false
        });
        
        toast(errorMessage, toastConfig);
      },
      options
    );
  };

  // Function to send location to API
  sendLocationToAPI = async (lat, lon) => {
    try {
      const response = await fetch('https://d1dgpoid6t01jm.cloudfront.net/user/update-lat-lon', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // Add authorization header if needed
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          lat: lat,
          lon: lon
        })
      });

      if (!response.ok) {
        throw new Error('Failed to update location');
      }

      const data = await response.json();
      console.log('Location updated successfully:', data);
      
    } catch (error) {
      console.error('Error updating location:', error);
      toast("Failed to update location. Please try again.", toastConfig);
    }
  };

  // Retry location if user wants to
  retryLocation = () => {
    this.getUserLocation();
  };

  back = e => {
    e.preventDefault();
    this.props.prevStep();
  };

  handleInputChange = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  async handleClick(e) {
    this.setState({ submitted: true }, () => {
      e.preventDefault();
      let self = this;
      if (
        this.state.assistance &&
        this.state.address &&
        this.state.landmark &&
        this.state.area &&
        this.state.pincode
      ) {
        var add = this.state;
        this.props.UserAddress(add);
        delete this.props.user.page;
        this.props.nextStep();
      } else {
        toast("Please input all the required data !!", toastConfig);
      }
    });
  }

  handleReset = () => {
    this.setState({
      assistance: "",
      address: "",
      landmark: "",
      area: "",
      name: "",
      phone: "",
      amount: ""
    });
  };

  handleClickforState() {
    console.log("some thing form state");
    this.setState({
      name: "",
      phone: ""
    });
  }

  myself() {
    var self = this;
    self.setState({
      name: this.name,
      phone: this.mobile
    });
  }

  render() {
    const { isGettingLocation, locationError, latitude, longitude } = this.state;

    return (
      <div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              {/* Location Status Section */}
              <div className="location-status" style={{ marginBottom: '20px', padding: '10px', border: '1px solid #ddd', borderRadius: '5px' }}>
                <h4>Location Information</h4>
                {isGettingLocation ? (
                  <div style={{ color: '#007bff' }}>
                    <FA name="spinner" spin /> Getting your location...
                  </div>
                ) : locationError ? (
                  <div style={{ color: 'red' }}>
                    <FA name="exclamation-triangle" /> {locationError}
                    <button 
                      onClick={this.retryLocation}
                      style={{ 
                        marginLeft: '10px', 
                        padding: '5px 10px', 
                        backgroundColor: '#007bff', 
                        color: 'white', 
                        border: 'none', 
                        borderRadius: '3px',
                        cursor: 'pointer'
                      }}
                    >
                      Retry
                    </button>
                  </div>
                ) : latitude && longitude ? (
                  <div style={{ color: 'green' }}>
                    <FA name="check-circle" /> Location captured successfully!
                    <div style={{ fontSize: '12px', marginTop: '5px' }}>
                      Lat: {latitude.toFixed(6)}, Lng: {longitude.toFixed(6)}
                    </div>
                  </div>
                ) : null}
              </div>

              <ValidatorForm onSubmit={this.handleClick}>
                <div className="form-group">
                  <div className="container-row">
                    <div className="radio" style={{ padding: '0px 10px', border: this.state.assistance === "myself" ? '2px solid #E9C589' : '2px solid transparent' }}>
                      <input
                        id="radio-1"
                        type="radio"
                        name="assistance"
                        value="myself"
                        checked={this.state.assistance === "myself"}
                        onChange={this.handleInputChange}
                        onClick={() => {
                          this.myself();
                        }}
                      />
                      <label htmlFor="radio-1" className="radio-label">
                        My Self
                      </label>
                    </div>
                    <div className="radio" style={{ padding: '0px 10px', border: this.state.assistance === "forothers" ? '2px solid #E9C589' : '2px solid transparent' }}>
                      <input
                        id="radio-2"
                        type="radio"
                        name="assistance"
                        value="forothers"
                        checked={this.state.assistance === "forothers"}
                        onChange={this.handleInputChange}
                        onClick={() => {
                          this.handleClickforState();
                        }}
                      />
                      <label htmlFor="radio-2" className="radio-label">
                        For Others
                      </label>
                    </div>
                  </div>
                </div>
                {this.state.assistance === "forothers" ? (
                  <div>
                    <div className="form-group inputField">
                      <TextValidator
                        label="Name *"
                        type="text"
                        placeholder="Enter Name"
                        className="form-control"
                        name="name"
                        onChange={this.handleInputChange}
                        value={this.state.name}
                        validators={["required"]}
                        errorMessages={"This field is mandatory!"}
                      />
                    </div>
                    <div className="form-group inputField">
                      <TextValidator
                        label="Contact Number *"
                        type="number"
                        placeholder="Enter Contact Number"
                        className="form-control"
                        name="phone"
                        onChange={this.handleInputChange}
                        value={this.state.phone}
                        validators={["required", "isPhoneMatch"]}
                        errorMessages={"This field is mandatory!"}
                      />
                    </div>
                  </div>
                ) : null}
                <div className="form-group inputField">
                  <TextValidator
                    type="text"
                    placeholder="Enter Your Address"
                    className="form-control"
                    name="address"
                    onChange={this.handleInputChange}
                    value={this.state.address}
                    validators={["required"]}
                    errorMessages={"This field is mandatory!"}
                  />
                </div>
                <div className="form-group inputField">
                  <TextValidator
                    placeholder="Landmark *"
                    className="form-control"
                    name="landmark"
                    type="text"
                    onChange={this.handleInputChange}
                    value={this.state.landmark}
                    validators={["required"]}
                    errorMessages={"This field is mandatory!"}
                  />
                </div>
                <div className="form-group inputField">
                  <TextValidator
                    placeholder="Area *"
                    className="form-control"
                    name="area"
                    type="text"
                    onChange={this.handleInputChange}
                    value={this.state.area}
                    validators={["required"]}
                    errorMessages={"This field is mandatory!"}
                  />
                </div>
                <div className="form-group inputField">
                  <TextValidator
                    placeholder="Pincode *"
                    className="form-control"
                    name="pincode"
                    type="number"
                    value={this.state.pincode}
                    onChange={this.handleInputChange}
                    validators={[
                      "required",
                      "minNumber:111111",
                      "maxNumber:999999"
                    ]}
                    errorMessages={"Please enter a valid pin code!"}
                    max="999999"
                    min="111111"
                    pattern="\d*"
                  />
                </div>
                <div className="iconContainerRow">
                  <FA
                    name="arrow-left"
                    onClick={this.back}
                    className="iconPrev"
                  />
                  <FA
                    name="arrow-right"
                    onClick={e => this.handleClick(e)}
                    className="iconNext"
                  />
                </div>
              </ValidatorForm>
              <ToastContainer transition={Flip} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = State => {
  return {
    user: State.bookSession,
    userDetail: State.userDetail.userlogindetails
  };
};

const mapDispatchToProps = dispatch => {
  return {
    UserAddress: address => {
      dispatch(userAddress(address));
    }
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Address)
);